import { render, staticRenderFns } from "./CoinBalance.vue?vue&type=template&id=65392a84&scoped=true&"
import script from "./CoinBalance.vue?vue&type=script&lang=js&"
export * from "./CoinBalance.vue?vue&type=script&lang=js&"
import style0 from "./CoinBalance.vue?vue&type=style&index=0&id=65392a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65392a84",
  null
  
)

export default component.exports